import React from "react";
import { Link } from "react-router-dom";


const HeroFeatures: React.FC = () => {
  return (
    <section className="hero-features-section pt-130 pb-130" style={{ background: "#00020F" }}>
      <div className="container-fluid" style={{ maxWidth: "1400px" }}>
        <div className="sec-title sec-title-center text-center mb-50">
          <span className="sub-title mb-15">How It Works</span>
          <h2 className="title mb-20">Up and running in days, not months</h2>
          <p className="mx-auto" style={{ maxWidth: "800px", display: "block", color: "#d2d2d2", fontSize: "18px", lineHeight: "1.6", marginBottom: "30px" }}>
            Software transitions are usually a headache. We made ours simple.
          </p>
          <Link to="/contact" className="thm-btn agency-btn">
            <span className="text">Talk To Our Team</span>
            <span className="arrow">
              <span className="arrow-icon">
                <svg
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="5.06592"
                    y="19.9785"
                    width="20.5712"
                    height="2.61221"
                    transform="rotate(-40.2798 5.06592 19.9785)"
                    fill="white"
                  />
                  <rect
                    x="7.97095"
                    y="7.24463"
                    width="2.61221"
                    height="2.61221"
                    transform="rotate(-40.2798 7.97095 7.24463)"
                    fill="white"
                  />
                  <rect
                    x="11.6523"
                    y="7.54834"
                    width="2.61221"
                    height="2.61221"
                    transform="rotate(-40.2798 11.6523 7.54834)"
                    fill="white"
                  />
                  <rect
                    x="15.334"
                    y="7.85205"
                    width="2.61221"
                    height="2.61221"
                    transform="rotate(-40.2798 15.334 7.85205)"
                    fill="white"
                  />
                  <rect
                    x="18.7119"
                    y="11.8374"
                    width="2.61221"
                    height="2.61221"
                    transform="rotate(-40.2798 18.7119 11.8374)"
                    fill="white"
                  />
                  <rect
                    x="18.4084"
                    y="15.52"
                    width="2.61221"
                    height="2.61221"
                    transform="rotate(-40.2798 18.4084 15.52)"
                    fill="white"
                  />
                  <rect
                    x="18.104"
                    y="19.2012"
                    width="2.61221"
                    height="2.61221"
                    transform="rotate(-40.2798 18.104 19.2012)"
                    fill="white"
                  />
                </svg>
                <svg
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="5.06592"
                    y="19.9785"
                    width="20.5712"
                    height="2.61221"
                    transform="rotate(-40.2798 5.06592 19.9785)"
                    fill="white"
                  />
                  <rect
                    x="7.97095"
                    y="7.24463"
                    width="2.61221"
                    height="2.61221"
                    transform="rotate(-40.2798 7.97095 7.24463)"
                    fill="white"
                  />
                  <rect
                    x="11.6523"
                    y="7.54834"
                    width="2.61221"
                    height="2.61221"
                    transform="rotate(-40.2798 11.6523 7.54834)"
                    fill="white"
                  />
                  <rect
                    x="15.334"
                    y="7.85205"
                    width="2.61221"
                    height="2.61221"
                    transform="rotate(-40.2798 15.334 7.85205)"
                    fill="white"
                  />
                  <rect
                    x="18.7119"
                    y="11.8374"
                    width="2.61221"
                    height="2.61221"
                    transform="rotate(-40.2798 18.7119 11.8374)"
                    fill="white"
                  />
                  <rect
                    x="18.4084"
                    y="15.52"
                    width="2.61221"
                    height="2.61221"
                    transform="rotate(-40.2798 18.4084 15.52)"
                    fill="white"
                  />
                  <rect
                    x="18.104"
                    y="19.2012"
                    width="2.61221"
                    height="2.61221"
                    transform="rotate(-40.2798 18.104 19.2012)"
                    fill="white"
                  />
                </svg>
              </span>
            </span>
          </Link>
        </div>
        <div className="row gx-5">
          {/* Step 1 */}
          <div className="col-lg-3 col-md-6 mt-30" style={{ position: "relative" }}>
            <div
              className="xb-feature-item h-100 wow fadeInUp"
              data-wow-delay="100ms"
              data-wow-duration="600ms"
            >
              <div className="xb-item--inner h-100 xb-border text-center d-flex flex-column justify-content-center" style={{ padding: "30px 40px" }}>
                <div className="xb-item--icon" style={{ display: "inline-flex", justifyContent: "center", alignItems: "center", backgroundColor: "transparent", backdropFilter: "blur(12px)", WebkitBackdropFilter: "blur(12px)", border: "1px solid rgba(255, 255, 255, 0.1)", width: "48px", height: "48px", borderRadius: "50%", margin: "0 auto", boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)" }}>
                  <span style={{ fontSize: "16px", color: "#fff", fontWeight: "700", lineHeight: "1" }}>1</span>
                </div>
                <div className="xb-item--holder">
                  <h2 className="xb-item--title" style={{ marginTop: "20px" }}>Strategize</h2>
                  <p className="xb-item--content">
                    We analyze your current workflow to identify high-impact automation opportunities tailored to your specific business goals.
                  </p>
                </div>
              </div>
            </div>
            {/* Arrow connector */}
            <div className="d-none d-lg-block" style={{ position: "absolute", top: "50%", right: "0px", transform: "translate(50%, -50%)", zIndex: 10 }}>
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#ba6be7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </div>
          </div>

          {/* Step 2 */}
          <div className="col-lg-3 col-md-6 mt-30" style={{ position: "relative" }}>
            <div
              className="xb-feature-item h-100 wow fadeInUp"
              data-wow-delay="200ms"
              data-wow-duration="600ms"
            >
              <div className="xb-item--inner h-100 xb-border text-center d-flex flex-column justify-content-center" style={{ padding: "30px 40px" }}>
                <div className="xb-item--icon" style={{ display: "inline-flex", justifyContent: "center", alignItems: "center", backgroundColor: "transparent", backdropFilter: "blur(12px)", WebkitBackdropFilter: "blur(12px)", border: "1px solid rgba(255, 255, 255, 0.1)", width: "48px", height: "48px", borderRadius: "50%", margin: "0 auto", boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)" }}>
                  <span style={{ fontSize: "16px", color: "#fff", fontWeight: "700", lineHeight: "1" }}>2</span>
                </div>
                <div className="xb-item--holder">
                  <h2 className="xb-item--title" style={{ marginTop: "20px" }}>Integrate</h2>
                  <p className="xb-item--content">
                    Our team builds and deploys custom AI agents into your existing systems with zero downtime or messy overhauls.
                  </p>
                </div>
              </div>
            </div>
            {/* Arrow connector */}
            <div className="d-none d-lg-block" style={{ position: "absolute", top: "50%", right: "0px", transform: "translate(50%, -50%)", zIndex: 10 }}>
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#ba6be7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </div>
          </div>

          {/* Step 3 */}
          <div className="col-lg-3 col-md-6 mt-30" style={{ position: "relative" }}>
            <div
              className="xb-feature-item h-100 wow fadeInUp"
              data-wow-delay="300ms"
              data-wow-duration="600ms"
            >
              <div className="xb-item--inner h-100 xb-border text-center d-flex flex-column justify-content-center" style={{ padding: "30px 40px" }}>
                <div className="xb-item--icon" style={{ display: "inline-flex", justifyContent: "center", alignItems: "center", backgroundColor: "transparent", backdropFilter: "blur(12px)", WebkitBackdropFilter: "blur(12px)", border: "1px solid rgba(255, 255, 255, 0.1)", width: "48px", height: "48px", borderRadius: "50%", margin: "0 auto", boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)" }}>
                  <span style={{ fontSize: "16px", color: "#fff", fontWeight: "700", lineHeight: "1" }}>3</span>
                </div>
                <div className="xb-item--holder">
                  <h2 className="xb-item--title" style={{ marginTop: "20px" }}>Launch</h2>
                  <p className="xb-item--content">
                    Go live in days, not months. Your automated ecosystem begins handling tasks, inquiries, and operations immediately.
                  </p>
                </div>
              </div>
            </div>
            {/* Arrow connector */}
            <div className="d-none d-lg-block" style={{ position: "absolute", top: "50%", right: "0px", transform: "translate(50%, -50%)", zIndex: 10 }}>
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#ba6be7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </div>
          </div>

          {/* Step 4 */}
          <div className="col-lg-3 col-md-6 mt-30" style={{ position: "relative" }}>
            <div
              className="xb-feature-item h-100 wow fadeInUp"
              data-wow-delay="400ms"
              data-wow-duration="600ms"
            >
              <div className="xb-item--inner h-100 xb-border text-center d-flex flex-column justify-content-center" style={{ padding: "30px 40px" }}>
                <div className="xb-item--icon" style={{ display: "inline-flex", justifyContent: "center", alignItems: "center", backgroundColor: "transparent", backdropFilter: "blur(12px)", WebkitBackdropFilter: "blur(12px)", border: "1px solid rgba(255, 255, 255, 0.1)", width: "48px", height: "48px", borderRadius: "50%", margin: "0 auto", boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)" }}>
                  <span style={{ fontSize: "16px", color: "#fff", fontWeight: "700", lineHeight: "1" }}>4</span>
                </div>
                <div className="xb-item--holder">
                  <h2 className="xb-item--title" style={{ marginTop: "20px" }}>Optimize</h2>
                  <p className="xb-item--content">
                    We provide continuous performance monitoring and proactive tweaks to ensure your AI delivers a consistent, high-yield ROI.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroFeatures;
